import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import { AysCodeGroup } from '@bindoc-projects/code-domain-lib';

export const BD_ICD_GROUP_CONTENT_CONDITION_ID = 'icdGroup';
export const FilterConditionIcdCodeGroupPluginType: FilterConditionPluginSpecification<
  AysCodeGroup[],
  FilterConditionIcdCodeGroupDto,
  BdIcdGroupContentCondition
> = {
  type: 'icdGroup',
  category: 'case',
  displayName: { de: 'ICD-Gruppe' },
  sortingIndex: 9,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionIcdCodeGroupDto,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionIcdCodeGroupPlugin(
        obj.groups.map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdIcdGroupContentCondition,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionIcdCodeGroupPlugin(
        (jsonObj.includes ?? []).map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionIcdCodeGroupPlugin([]);
  },
};

export class FilterConditionIcdCodeGroupPlugin extends FilterConditionPluginImpl<
  AysCodeGroup[],
  FilterConditionIcdCodeGroupDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCodeGroup[],
    FilterConditionIcdCodeGroupDto,
    BdIcdGroupContentCondition
  > = FilterConditionIcdCodeGroupPluginType;

  constructor(private groups: AysCodeGroup[]) {
    super(FilterConditionIcdCodeGroupPluginType.type);
  }

  clone(): FilterConditionIcdCodeGroupPlugin {
    return new FilterConditionIcdCodeGroupPlugin([
      ...this.groups.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionIcdCodeGroupPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.groups,
        other.groups,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.groups.length === 0) {
      return 'Mindestens eine ICD-Gruppe auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdIcdGroupContentCondition(this.groups, []);
  }

  toJSON(): FilterConditionIcdCodeGroupDto | null {
    return {
      type: this.type,
      groups: this.groups,
    };
  }

  toText(): string | null {
    return 'ICD-Gruppe';
  }

  toValue(): AysCodeGroup[] {
    return this.groups;
  }
}

export class BdIcdGroupContentCondition extends BdContentCondition<AysCodeGroup> {
  constructor(includes: AysCodeGroup[], excludes: AysCodeGroup[]) {
    super(BD_ICD_GROUP_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionIcdCodeGroupDto {
  type: string;
  groups: AysCodeGroup[];
}
